import { Spinner } from '@chakra-ui/react';
import React from 'react';

import { LoadingMask } from './LoadingMask';

export const CmLoading: React.FC = () => {
  return (
    <LoadingMask>
      {/*
       // @ts-ignore TS2590 */}
      <Spinner
        thickness="4px"
        speed="0.75s"
        emptyColor="gray.200"
        color="gray.700"
        size="xl"
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
      />
    </LoadingMask>
  );
};
